import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import logo from "@/assets/logo2-kmkit.png";
import { useLanguage } from "@/contexts/LanguageContext";
import { industriesData } from "@/data/industriesData";
import { industryTranslations } from "@/data/industriesTranslations";

const Footer = () => {
  const { language, t, getLocalizedPath } = useLanguage();
  
  // Get first 5 industries with translations
  const displayedIndustries = industriesData.slice(0, 5).map(ind => ({
    slug: ind.slug,
    title: industryTranslations[ind.slug]?.[language]?.title || industryTranslations[ind.slug]?.en?.title || ind.slug
  }));

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img src={logo} alt="KM KIT" className="h-16 mb-4 brightness-0 invert" />
            <p className="text-sm text-primary-foreground/80">
              {t("hero.title").substring(0, 60)}...
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">{t("footer.quickLinks")}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to={getLocalizedPath("")} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link to={getLocalizedPath("products")} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  {t("nav.products")}
                </Link>
              </li>
              <li>
                <Link to={getLocalizedPath("industries")} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  {t("nav.industries")}
                </Link>
              </li>
              <li>
                <Link to={getLocalizedPath("contacts")} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  {t("nav.contacts")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="font-semibold mb-4">{t("footer.industries")}</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              {displayedIndustries.map((ind) => (
                <li key={ind.slug}>
                  <Link 
                    to={getLocalizedPath(`industries/${ind.slug}`)}
                    className="hover:text-primary-foreground transition-colors"
                  >
                    {ind.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">{t("footer.contact")}</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Mail className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <a href="mailto:info@kmkit.com" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                  info@kmkit.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <div className="text-primary-foreground/80">
                  <div>KM KIT mbH</div>
                  <div>Aschmattstraße 8</div>
                  <div>76532 Baden-Baden</div>
                  <div>Germany</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-foreground/20 text-center text-sm text-primary-foreground/60">
          <p>&copy; 2025 PV91285. {t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
